import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  buttonContent: {
    display: 'flex',
    gap: '5px',
    fontSize: '12px',
    alignItems: 'center',
    color: theme.palette.primary.primary800,
  },
  buttonStopContent: {
    display: 'flex',
    gap: '5px',
    fontSize: '12px',
    alignItems: 'center',
    color: theme.palette.error.error600,
  },
  iconeRiskEvolution: {
    borderRadius: '200px',
    boxShadow: '0px 18px 40px 0px rgba(112, 144, 176, 0.12)',
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: '-10px',
    top: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  globalScore: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    textAlign: 'center',
    color: theme.palette.black.dark,
    position: 'relative',
    bottom: '44px',
    '& .score': {
      fontSize: '34px',
    },
    '& .max-score': {
      opacity: 0.4,
    },
  },
  globalScoreChart: {
    alignSelf: 'center',
    position: 'relative',
    margin: '10px',
    marginBottom: '5px',
  },
}));

export default useStyles;
